import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import MenuItem from '@material-ui/core/MenuItem';
import DropIn from 'braintree-web-drop-in-react';

const styles = theme => ({
  grid: {
    padding: theme.spacing(5),
  },
  instructions: {
    paddingBottom: theme.spacing(2),
  },
  noPaymentText: {
    padding: theme.spacing(2),
    textAlign: 'center',
  },
});

function PaymentForm(props) {
  const {
    classes,
    braintreeCustomer,
    activePayment,
    handleSelectPayment,
    handleToggleSavePayment,
    savePayment,
    handleInstance,
    braintreeClientToken,
    paymentRequired,
    oscarAccount,
    cart,
    handleStoreCreditChange,
    useStoreCredit,
    methodRequired,
    shippingCharge,
  } = props;


  // calculate totals
  const ct = cart.total_excl_tax;
  const sc = shippingCharge.excl_tax;
  let t = parseFloat(cart.total_tax) + parseFloat(shippingCharge.tax);
  t = t.toFixed(2);
  let tt = parseFloat(cart.total_incl_tax) + parseFloat(shippingCharge.incl_tax);
  tt = tt.toFixed(2);

  return (
    <React.Fragment>
      {paymentRequired
        ? (
          <Grid container className={classes.grid} spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h6">Cart Total</Typography>
              <Typography>{'Cart Total: $' + ct}</Typography>
              <Typography>{'Shipping: $' + sc}</Typography>
              <Typography>{'Tax: $' + t}</Typography>
              <Typography><strong>{'Total: $' + tt}</strong></Typography>
              {(oscarAccount && oscarAccount.balance > 0) && (
                <React.Fragment>
                  <Typography>{'Store credit available: $' + oscarAccount.balance}</Typography>
                  <FormControlLabel
                    control={(
                      <Checkbox
                        checked={useStoreCredit}
                        onChange={e => handleStoreCreditChange(e)}
                        color="secondary"
                      />
                    )}
                    label="Use store credit towards payment"
                  />
                </React.Fragment>
              )}
            </Grid>
            { methodRequired && (
              <React.Fragment>
                <Grid item xs={12}>
                  <Typography variant="h6">Payment Method</Typography>
                </Grid>
                { braintreeCustomer && braintreeCustomer.payment_methods && braintreeCustomer.payment_methods.length > 0 && (
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>Payment Options</InputLabel>
                      <Select
                        placeholder="Select Payment Method"
                        value={activePayment}
                        className=""
                        onChange={e => handleSelectPayment(e)}
                        input={(
                          <OutlinedInput
                            labelWidth={130}
                          />
                        )}
                      >
                        <MenuItem key="newaddress" value={0}>New Payment Method&nbsp;&nbsp;</MenuItem>
                        {braintreeCustomer.payment_methods.map((method, i) => {
                          if (method.type === 'cc') {
                            return <MenuItem key={method.token} value={i + 1}>{'Card ending in: ' + method.last4}</MenuItem>;
                          }
                          if (method.type === 'paypal') {
                            return <MenuItem key={method.token} value={i + 1}>{'PayPal Account: ' + method.email}</MenuItem>;
                          }
                          return <Typography>Unnexpected payment method type</Typography>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
                { activePayment === 0
                  ? (
                    <React.Fragment>
                      <Grid item xs={12} sm={6}>
                        {/* Braintree DropIn */}
                        <DropIn
                          className={classes.cardElement}
                          options={{
                            authorization: braintreeClientToken,
                            paypal: {
                              flow: 'vault',
                            },
                          }}
                          onInstance={e => handleInstance(e)}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={<Checkbox color="secondary" name="saveCard" checked={savePayment} value="yes" />}
                          label="Remember payment method for next time"
                          onChange={e => handleToggleSavePayment(e)}
                        />
                      </Grid>
                    </React.Fragment>
                  )
                  : (
                    <Grid item xs={6}>
                      {braintreeCustomer.payment_methods[activePayment - 1].type === 'cc' && (
                        <React.Fragment>
                          <Typography className={classes.instructions} variant="subtitle1" color="textSecondary">Charge will be made to this saved card:</Typography>
                          {braintreeCustomer.payment_methods[activePayment - 1] && (
                            <Grid container>
                              <Grid item xs={6}>
                                <Typography gutterBottom>Card Type:</Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography gutterBottom>
                                  {braintreeCustomer.payment_methods[activePayment - 1].card_type}
                                </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography gutterBottom>Card Number:</Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography gutterBottom>
                                  {braintreeCustomer.payment_methods[activePayment - 1].last4}
                                </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography gutterBottom>Expires:</Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography gutterBottom>
                                  {braintreeCustomer.payment_methods[activePayment - 1].expiration_month + '/' + braintreeCustomer.payment_methods[activePayment - 1].expiration_year}
                                </Typography>
                              </Grid>
                            </Grid>
                          )}
                        </React.Fragment>
                      )}
                      {braintreeCustomer.payment_methods[activePayment - 1].type === 'paypal' && (
                        <React.Fragment>
                          <Typography className={classes.instructions} variant="subtitle1" color="textSecondary">Charge will be made to PayPal account:</Typography>
                          {braintreeCustomer.payment_methods[activePayment - 1] && (
                            <Grid container>
                              <Grid item xs={12}>
                                <Typography gutterBottom>
                                  {braintreeCustomer.payment_methods[activePayment - 1].email}
                                </Typography>
                              </Grid>
                            </Grid>
                          )}
                        </React.Fragment>
                      )}
                    </Grid>
                  )
              }
              </React.Fragment>
            )}
          </Grid>
        )
        : (
          <Typography variant="subtitle1" className={classes.noPaymentText} color="secondary">No Payment Required!</Typography>
        )
      }
    </React.Fragment>
  );
}

PaymentForm.propTypes = {
  classes: PropTypes.object.isRequired,
  braintreeCustomer: PropTypes.object.isRequired,
  activePayment: PropTypes.number.isRequired,
  handleSelectPayment: PropTypes.func.isRequired,
  handleToggleSavePayment: PropTypes.func.isRequired,
  savePayment: PropTypes.bool.isRequired,
  handleInstance: PropTypes.func.isRequired,
  braintreeClientToken: PropTypes.string.isRequired,
  paymentRequired: PropTypes.bool.isRequired,
  cart: PropTypes.object.isRequired,
  oscarAccount: PropTypes.object.isRequired,
  useStoreCredit: PropTypes.bool.isRequired,
  handleStoreCreditChange: PropTypes.func.isRequired,
  methodRequired: PropTypes.bool.isRequired,
  shippingCharge: PropTypes.object.isRequired,
};

export default withStyles(styles)(PaymentForm);
